/**
 * DOUGHNUT_CHART_CONFIG: a JSON object representing a schema used to drive doughnut charts for HighCharts.
 */
export const CMA_DOUGHNUT_CHART_CONFIG = {
	chart: {
		margin: 0,
		spacing: 0,
		style: {
			fontFamily: '"FortBook", Arial, sans-serif',
			color: null
		},
		type: 'pie'
	},
	plotOptions: {
		pie: {
			dataLabels: {
				enabled: false
			},
			innerSize: '80%',
			startAngle: 0,
			endAngle: 360,
			size: '140px'
		}
	},
	tooltip: {
		backgroundColor: '#f9f9f9',
		borderColor: '#a5a5a5',
		borderRadius: 0,
		shadow: false,
		useHTML: true,
		style: {
			fontFamily: '"FortBook", Arial, sans-serif'
		}
	},
	colors: null,
	title: {
		text: null, // this.hideTitle ? '' : this.seriesTitle,
		widthAdjust: null,
		style: {
			color: '#000000',
			fontFamily: 'FortBold, Arial, sans-serif'
		},
		align: 'center',
		verticalAlign: 'middle'
	},
	series: null
};
